function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  background-color: #e6e6e6;\n  height: ", "px;\n  width: ", "px;\n  border: solid 8px ", ";\n  box-sizing: border-box;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 5px 0;\n  position: relative;\n  box-shadow: 0 0 4px 0 #9b9b9b;\n  border-radius: 5px;\n  display: inline-block;\n  height: ", "px;\n  width: ", "px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: ", ";\n  z-index: 1;\n  transition: background 200ms linear;\n  pointer-events: none;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import * as React from 'react';
import styled from 'styled-components';
var MediaOverlay = styled.div(_templateObject(), function (props) {
  return props.messageSelected ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0)";
});
var LinkMediaContainer = styled.a(_templateObject2(), function (props) {
  return props.height;
}, function (props) {
  return props.width;
});
var ThumbnailVideo = styled.video(_templateObject3(), function (props) {
  return props.height;
}, function (props) {
  return props.width;
}, function (props) {
  return props.borderColor;
});

var VideoItem = function VideoItem(props) {
  var videoUrl = props.videoUrl,
      thumbnailUrl = props.thumbnailUrl,
      loaded = props.loaded,
      videoDimensions = props.videoDimensions,
      messageSelected = props.messageSelected,
      alt = props.alt,
      borderColor = props.borderColor,
      onPlay = props.onPlay;
  return React.createElement(LinkMediaContainer, {
    "data-test-id": 'VideoItem',
    width: videoDimensions.width,
    height: videoDimensions.height
  }, React.createElement(MediaOverlay, {
    messageSelected: messageSelected
  }), React.createElement(ThumbnailVideo, {
    onPlay: onPlay,
    preload: "none",
    controls: true,
    alt: loaded ? '' : alt ? alt : 'Video sent by Customer',
    width: videoDimensions.width,
    height: videoDimensions.height,
    borderColor: borderColor ? borderColor : '#dedede',
    poster: thumbnailUrl
  }, React.createElement("source", {
    src: videoUrl,
    type: "video/mp4"
  })));
};

export default VideoItem;